<template>
<w-sliding-popup ref="workDetailsSlidingPopup" :type="popupType" :title="workName" :width="viewTypeTimeLine ? '1000px' : '600px'" @close="onClose">
  <div slot="title" v-if="!viewTypeTimeLine">
    <el-button v-show="adminFlag" type="solid" size="small" @click="onClickWorkUpdate">작업 수정</el-button>
    <el-button v-show="adminFlag" size="small" @click="onDeleteButtonClick">작업 삭제</el-button>
  </div>
  <div slot="content">
    <el-steps :active="activeStep" finish-status="success">
      <el-step title="작업등록"></el-step>
      <el-step title="처리중"></el-step>
      <el-step title="작업완료"></el-step>
    </el-steps>

    <el-tabs class="tab-button" v-model="activeTabName" @tab-click="changeActiveTab">
      <!-- 작업 정보 확인 -->
      <el-tab-pane :label="tabs.workInfo.label" :name="tabs.workInfo.name" :key="tabs.workInfo.name">
        <w-work-info-check-form class="mr-b25" :form-datas="workFormDatas" :work-status="workLastStatus" ref="workInfoCheckForm" @add-details-info="setDetailsInfo" />
        <el-row type="flex" justify="space-between" class="title-bar">
          <div class="title-h4">{{ `작업 처리 ${activeStep < 3 ? '등록' : '이력'}` }}</div>
          <span v-if="activeStep < 3">
            <span class="mr-r4">{{file.fileName}}</span>
            <el-upload :class="$style['inline-block']" :file-list="fileInfo" :auto-upload="false" :on-change="changeUploadFile" :before-upload="(file) => file" action="" :show-file-list="false">
              <el-button size="mini">파일업로드</el-button>
            </el-upload>
            <el-button type="primary" size="mini" @click="onClickAddWorkHist">등록</el-button>
          </span>
        </el-row>
        <!-- 처리 이력 -->
        <el-row v-if="activeStep < 3" class="mr-b25" style="height:127px;">
          <el-select class="flexible-input mr-r4" style="height:100%;width:105px;" v-model="workProcessSelectValue">
            <el-option label="처리중" value="P"></el-option>
            <el-option label="처리성공" value="S"></el-option>
            <el-option label="처리실패" value="F"></el-option>
          </el-select>
          <el-input style="height:100%;width:calc(100% - 113px);" type="textarea" :autosize="{ minRows: 5, maxRows: 10}" v-model="workProcessInputValue"> </el-input>
        </el-row>
        <el-table-wrapper border :data="workProcessTableDatas" :columns="columns" :column-default="columnDefault" :show-search-tool="false" :show-custom-header="true" :show-overflow-tooltip="true" :pagination="false" header-align="center">
          <template slot-scope="scope" slot="file-slot">
              <span v-if="scope.row.fileName" class="c-pointer" @click="onClickFileDownload(scope.row)" ><i class="far fa-file-download"></i></span>
              <span v-else>{{ EMPTY_TEXT }}</span>
            </template>
          <template slot-scope="scope" slot="delete-slot">
              <span v-if="scope.row.workStatus === 'P' && activeStep < 3" class="c-pointer" @click="onClickDeleteWorkProcessHist(scope.row)"><i class="fal fa-times"></i></span>
              <span v-else>{{ EMPTY_TEXT }}</span>
            </template>
          <template slot-scope="scope" slot="contents-slot">
              <span v-if="isEmptyNotFlag(scope.row.processContents)">[{{ getStatusFormatter(scope.row.workStatus) }}]{{ scope.row.processContents }}</span>
              <span v-else>{{ EMPTY_TEXT }}</span>
            </template>
        </el-table-wrapper>
      </el-tab-pane>
      <!-- 작업 장비 정보 -->
      <el-tab-pane :label="tabs.workObjInfo.label" :name="tabs.workObjInfo.name" :key="tabs.workObjInfo.name">
        <el-table :data="workObjList">
          <el-table-column prop="objName" label="장비명"/>
          <el-table-column prop="ipaddress" label="IP">
            <template slot-scope="scope">
              <span>{{ scope.row.ipaddress ? scope.row.ipaddress : '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="event" width="105" label="이벤트금지" align="center" header-align="center">
            <template slot-scope="scope">
              <el-checkbox disabled v-model="scope.row.exceptEvent" true-label="Y" false-label="N"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column prop="resource" width="95" label="수집금지" align="center" header-align="center">
            <template slot-scope="scope">
              <el-checkbox disabled v-model="scope.row.exceptResource" true-label="Y" false-label="N"></el-checkbox>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <!-- 유지보수업체 정보 -->
      <el-tab-pane :label="tabs.maintenanceInfo.label" :name="tabs.maintenanceInfo.name" :key="tabs.maintenanceInfo.name">
        <el-table :data="maintenanceList">
          <el-table-column prop="maintenanceCompany" label="업체명">
            <template slot-scope="scope">
              <span>{{ scope.row.maintenanceCompany ? scope.row.maintenanceCompany : '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="maintenanceManager" label="담당자명">
            <template slot-scope="scope">
              <span>{{ scope.row.maintenanceManager ? scope.row.maintenanceManager : '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="maintenanceContact" label="연락처">
            <template slot-scope="scope">
              <span>{{ scope.row.maintenanceContact ? scope.row.maintenanceContact : '-' }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</w-sliding-popup>
</template>

<script>
import { isNil, clone, head } from 'lodash';
import { MANAGERTYPE } from '@/constants/account';
import { columnDefault } from '@/constants/table';
import MsgUtil from '@/utils/message';
import { getValueAfterCheckEmpty, EMPTY_TEXT } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import workManageAPI from '@/api/work/work';
import { checkFileSize } from '@/utils/file';
import WWorkInfoCheckForm from '@/views/work/popup/components/WorkInfoCheckForm';

export default {
  name: 'WWorkDetailsSlidingPopup',
  components: {
    WWorkInfoCheckForm,
  },
  data() {
    return {
      tabs: {
        workInfo: {
          name: 'workInfo',
          label: '작업정보 확인',
          active: false,
        },
        workObjInfo: {
          name: 'workObjInfo',
          label: '작업대상 장비',
          active: false,
        },
        maintenanceInfo: {
          name: 'maintenanceInfo',
          label: '유지보수 업체',
          active: false,
        },
      },
      activeTabName: 'workInfo',
      activeStep: 1,
      workObjList: [],
      maintenanceList: [],
      workLastStatus: null,
      workUpdatePopupParams: {},
      workProcessSelectValue: 'P',
      workProcessInputValue: null,
      columnDefault,
      columns: [
        {
          prop: 'checkDatetime',
          label: '작성일시',
          searchable: true,
          formatter: this.getDateFormatter,
        },
        {
          prop: 'managerName',
          label: '작성자',
          searchable: true,
          formatter: this.getManagerFormatter,
        },
        {
          label: '내용',
          searchable: true,
          scopedSlot: 'contents-slot',
        },
        {
          label: '파일',
          searchable: true,
          align: 'center',
          scopedSlot: 'file-slot',
        },
      ],
      workProcessTableDatas: [],
      fileInfo: [],
      file: {},
      EMPTY_TEXT,
      isDeleteWorkScheduleAllCheck: false,
      deleteDialogVisible: false,
      states: { checked: true },
      viewTypeTimeLine: false,
      popupType: 'common', // default
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
    workName() {
      return isNil(this.workFormDatas) ? EMPTY_TEXT : this.workFormDatas.workName;
    },
    /**
     * [isShowAdmin 계정이 addmin인지 확인]
     * @author {Yang}
     */
    adminFlag() {
      return MANAGERTYPE.ADMIN === this.userInfo.managerType;
    },
    showSettingView() {
      return this.$store.state.common.showSettingView;
    },
    visible() {
      return this.$store.state.popup.showWorkDetailsSlidingPopup;
    },
    workFormDatas() {
      return this.$store.state.popup.workDetailsSlidingPopupParams;
    },
  },
  watch: {
    visible: {
      handler(value) {
        if (value) {
          this.open();
        } else {
          this.close();
        }
      },
    },
  },
  beforeDestroy() {
    if (this.visible) {
      this.close();
    }
  },
  methods: {
    open() {
      this.$refs.workDetailsSlidingPopup.open();
      this.viewTypeTimeLine = isNil(this.workFormDatas.viewTypeTimeLine) ? false : this.workFormDatas.viewTypeTimeLine;
      this.clearData();
      this.popupType = this.showSettingView ? 'setting' : 'common';
      if (this.adminFlag) {
        this.columns = [
          {
            prop: 'checkDatetime',
            label: '작성일시',
            searchable: true,
            formatter: this.getDateFormatter,
          },
          {
            prop: 'managerName',
            label: '작성자',
            searchable: true,
            formatter: this.getManagerFormatter,
          },
          {
            label: '내용',
            searchable: true,
            scopedSlot: 'contents-slot',
          },
          {
            label: '파일',
            searchable: true,
            align: 'center',
            scopedSlot: 'file-slot',
          },
          {
            label: '삭제',
            searchable: true,
            align: 'center',
            scopedSlot: 'delete-slot',
          },
        ];
      } else {
        this.columns = [
          {
            prop: 'checkDatetime',
            label: '작성일시',
            searchable: true,
            formatter: this.getDateFormatter,
          },
          {
            prop: 'managerName',
            label: '작성자',
            searchable: true,
            formatter: this.getManagerFormatter,
          },
          {
            label: '내용',
            searchable: true,
            scopedSlot: 'contents-slot',
          },
          {
            label: '파일',
            searchable: true,
            align: 'center',
            scopedSlot: 'file-slot',
          },
        ];
      }
      this.$nextTick(() => {
        this.$refs.workInfoCheckForm.loadStore();
        this.workProcessLoadStore();
      });
    },
    /**
     * [moveActiveTab 탭의 이동]
     * @author {Yang}
     */
    moveActiveTab(value) {
      switch (value) {
        case 'A':
          this.activeStep = 1;
          break;
        case 'P':
          this.activeStep = 2;
          break;
        case 'F':
        case 'S':
          this.activeStep = 3;
          break;
        default:
          this.activeStep = 1;
      }
    },
    close() {
      this.$refs.workDetailsSlidingPopup.close();
    },
    onClose() {
      this.$store.dispatch('closeWorkDetailsSlidingPopup');
    },
    /**
     * 데이터 빈값 확인
     * @author Yang
     */
    getValueAfterCheckEmpty(value) {
      return isNil(value) ? EMPTY_TEXT : getValueAfterCheckEmpty(value);
    },
    /**
     * 작업변경 버튼 click
     * @author jeee12
     */
    onClickWorkUpdate() {
      // this.$emit('update-button-click', this.workUpdatePopupParams);
      const params = { workUpdatePopupParams: this.workUpdatePopupParams, ...this.workFormDatas };
      this.$store.dispatch('updateWorkDetail', params);
    },
    /**
     * 작업변경 팝업 파라미터 설정
     * @author jeee12
     */
    setDetailsInfo(value) {
      const workDatas = clone(this.workFormDatas);
      this.workObjList = clone(value.objList);
      this.maintenanceList = clone(value.maintenanceList);
      this.workUpdatePopupParams = Object.assign(workDatas, value);
    },
    /**
     * [getDateFormatter 테이블 날짜 포맷터]
     * @author {Yang}
     */
    getDateFormatter(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : getDateToString(value);
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author Yang
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * [workProcessLoadStore 작업 처리 등록 리스트 출력]
     * @author {Yang}
     * @return {[type]} [description]
     */
    workProcessLoadStore() {
      const params = {
        workSeqNumber: this.workFormDatas.workSeqNumber,
      };
      workManageAPI.getWorkProcessHistList(params).then((result) => {
        if (result.data.success === true) {
          this.workProcessTableDatas = result.data.data;
          this.workLastStatus = head(result.data.data).workStatus;
          this.moveActiveTab(this.workLastStatus);
        }
      });
    },
    /**
     * [getManagerFormatter 작성자 포맷]
     * @author {Yang}
     */
    getManagerFormatter(row, column, value) {
      if (isNil(value)) {
        return EMPTY_TEXT;
      }
      return `${value} (${row.managerId})`;
    },
    onDeleteButtonClick() {
      const messageData = MsgUtil.getBasicConfirmData(MsgUtil.action.DELETE);
      if (this.workFormDatas.scheduleType === 'O') {
        this.$confirm(...messageData).then(() => {
          this.onClickDeleteWork();
        });
      } else {
        /* eslint-disable  */
        const me = this;
        const message = messageData[0];
        this.isDeleteWorkScheduleAllCheck = true;

        // TODO v-model이 적용되지 않아 change 이벤트를 이용해 값을 설정하고 최초에는 항상 선택이 되도록 checked 속성과 beforeClose에서 추가적으로 처리힘
        // v-model 사용하여 처리 가능할 경우 위의 처리들 제거 필요.
        const messageRenderer = (
          <div>
          {(<div style="margin-bottom:5px;">{ message }</div>)}
          {(<el-checkbox checked={ true } onChange={ (value) => { me.isDeleteWorkScheduleAllCheck = value; } }>추가적으로 진행되는 작업 포함</el-checkbox>)}
          </div>
        );

        this.$msgbox({
          title: messageData[1],
          message: messageRenderer,
          showCancelButton: true,
          ...MsgUtil.defaultConfirmButton,
          customClass: 'confirm-box',
          beforeClose: (action, instance, done) => {
            messageRenderer.children[1].componentInstance.model = true;
            done();
          }
        }).then(() => {
          this.onClickDeleteWork();
        }).catch(() => {});
        /* eslint-enable  */
      }
    },
    /**
     * [onClickAddWorkHist 작업 의견 등록]
     * @author {Yang}
     */
    onClickAddWorkHist() {
      const fileInfo = this.file.fileInfo;
      const workSeqNumber = this.workFormDatas.workSeqNumber;
      const workName = this.workLastStatus;
      const workStatus = this.workProcessSelectValue;
      const processContents = this.workProcessInputValue;
      const formParams = new FormData();
      formParams.append('file', fileInfo);
      formParams.append('workSeqNumber', workSeqNumber);
      formParams.append('workStatus', workStatus);
      formParams.append('processContents', processContents);
      formParams.append('workName', workName);
      workManageAPI
        .addWorkProcessHist(formParams)
        .then((result) => {
          if (result.data.success === true) {
            this.$message(MsgUtil.getResultMsgData(MsgUtil.action.REGIST, '작업 처리 내용', true));
            this.file = {};
            this.fileInfo = [];
            this.workProcessSelectValue = 'P';
            this.workProcessInputValue = '';
            this.moveActiveTab(workStatus);
          } else {
            this.$message(MsgUtil.getCustomResultMsgData(result.data.message, false));
          }
          this.workProcessLoadStore();
        })
        .catch(() => {
          this.$message(MsgUtil.getResultMsgData(MsgUtil.action.REGIST, '작업 처리 내용', false));
        });
    },
    /**
     * 파일 업로드 시 데이터 설정
     * @author Yang
     * @param  {Object} item 파일 정보
     * @return {[type]}      [description]
     */
    changeUploadFile(item) {
      const result = checkFileSize(item.raw.size);
      if (result.enable !== true) {
        this.$message(MsgUtil.getCustomMsgData(result.message));
        return;
      }
      this.$set(this.file, 'fileInfo', item.raw);
      this.$set(this.file, 'fileName', item.name);
    },
    /**
     * [clearData 데이터 초기화]
     * @author {Yang}
     */
    clearData() {
      this.workProcessTableDatas = [];
      this.activeTabName = 'workInfo';
      this.file = {};
      this.fileInfo = [];
      this.activeStep = 1;
      this.workUpdatePopupParams = {};
      this.workProcessSelectValue = 'P';
      this.workProcessInputValue = '';
    },
    /**
     * [onClickFileDownload 파일 다운로드]
     * @author {Yang}
     */
    onClickFileDownload(row) {
      const params = {
        attachFileId: row.attachFileId,
      };
      workManageAPI.exportWorkProcessHistFileDownload(params);
    },
    /**
     * [onClickDeleteWorkProcessHist 작업 처리 삭제]
     * @author {Yang}
     */
    onClickDeleteWorkProcessHist(row) {
      const params = {
        seqNumber: row.seqNumber,
        attachFileId: row.attachFileId,
        workSeqNumber: row.workSeqNumber,
      };

      const target = '작업 처리 내용';
      workManageAPI
        .deleteWorkProcessHist(params)
        .then((result) => {
          if (result.data.success === true) {
            this.$message(MsgUtil.getResultMsgData(MsgUtil.action.DELETE, target, true));
            this.workProcessLoadStore();
            this.moveActiveTab(result.data.data);
          } else {
            this.$message(MsgUtil.getResultMsgData(MsgUtil.action.DELETE, target, false));
          }
        })
        .catch(() => {
          this.$message(MsgUtil.getResultMsgData(MsgUtil.action.DELETE, target, false));
        });
    },
    /**
     * [onClickDeleteWork 작업삭제]
     * @author {Yang}
     */
    onClickDeleteWork() {
      const params = clone(this.workFormDatas);
      params.isDeleteScheduleAll = this.isDeleteWorkScheduleAllCheck;
      workManageAPI.deleteWork(params).then((result) => {
        if (result.data.success === true) {
          this.close();
        }
        this.deleteDialogVisible = false;
      });
    },
    /**
     * [getStatusFormatter 상태 포맷터]
     * @author {Yang}
     */
    getStatusFormatter(value) {
      switch (value) {
        case 'A':
          return '작업 등록';
        case 'P':
          return '처리 중';
        case 'F':
        case 'S':
          return '처리 완료';
        default:
          return EMPTY_TEXT;
      }
    },
    /**
     * [isEmptyNotFlag 빈값인지 아닌지 판단]
     * @author {Yang}
     */
    isEmptyNotFlag(value) {
      return !isNil(value);
    },
    changeActiveTab() {
      const activeTab = this.tabs[this.activeTabName];
      activeTab.active = true;
      if (!isNil(this.activeTab)) {
        this.activeTab.active = false;
      }
      this.activeTab = activeTab;
    },
  },
};
</script>

<style module>
.inline-block {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/WorkDetailsSlidingPopup/index.vue